// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"eb25785a","481":"c199471f"}[chunkId] + ".chunk.js";
};